export default {"src":"/_next/static/media/documents.7b562200.svg","height":35,"width":32,"blurWidth":0,"blurHeight":0};